import { useState } from "react";
import { styled } from "@mui/material";
import { Alert } from "@kaltura/ds-react-components";

export interface PlayerNotSupportedProps {
    title: string;
}

const StyledAlert = styled(Alert)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));

/**
 * media-page player not supported alert
 */
export function PlayerNotSupported(props: PlayerNotSupportedProps) {
    const { title } = props;

    const [showAlert, setShowAlert] = useState(true);

    return (
        <>
            {showAlert && (
                <StyledAlert
                    severity="info"
                    onClose={() => {
                        setShowAlert(false);
                    }}
                >
                    {title}
                </StyledAlert>
            )}
        </>
    );
}

export default PlayerNotSupported;
